import React, { useContext } from 'react';
import Context from '../../../../utils/context';
import Typography from '../typography';
import { getQuestionHeadingScale } from '../question_wrapper/question_typography';

const QuestionHeading = ({ as = 'h1', variant = 'headingXl', children, scale = true }) => {
  const context = useContext(Context);
  const isMobile = context?.viewport?.getIsMobile?.() ?? false;
  const text = typeof children === 'string' ? children : '';
  const scaledStyle = scale && text ? getQuestionHeadingScale(text, { isMobile }) : undefined;
  const style = { fontWeight: 'var(--font-weight-medium)', ...scaledStyle };

  return (
    <Typography variant={variant} as={as} align='left' style={style}>
      {children}
    </Typography>
  );
};

export default QuestionHeading;
